// src/constants/constants.ts

import {AurColorPickerOptionsProp} from '../components/common/aur-color-picker/AurColorPicker';
import config from '../config';

// API Endpoints
export const SSE_ENDPOINT = `${config.API_BASE_URL}/v1/usermanagement/bulkupload/subscribe`;
export const SSE_ENDPOINT_ECA = `${config.API_BASE_URL}/v1/eca`;

// App-specific settings
export const ASK_LIO_KNOWLEDGE_BASE = 'Aurora';
// Regular Expressions

export const EMAIL_ADDRESS_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MAX_IP_ADDRESS_COUNT = 10;

//These fields allow alphanumeric characters.
// In addition, they allow for hyphen and single quote.
// No other special characters are allowed.
// These fields allow for English as well as non-English text including CJK.
export const TEAM_MEMBER_NAME_REGEX = /^[\p{L}\p{N}'-]+$/u;

// In addition, they allow for hyphen,underscore and single quote.
// eslint-disable-next-line no-useless-escape
export const CUSTOM_INDEX_NAME_REGEX = /^[\p{L}\p{N}'_ \-]+$/u;

// Auth settings

export const POPUP_BUTTON_STYLE = {
  STACKED: 'stacked',
  SIDEBYSIDE: 'sideBySide',
};

export const IPV4_REGEX =
  /^(?!0(\.0){3}$)(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}$/;
export const IPV6_REGEX =
  /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}(:[0-9a-fA-F]{1,4}){1,6}|::([0-9a-fA-F]{1,4}:){0,7}[0-9a-fA-F]{1,4}|::([0-9a-fA-F]{1,4}){1,7}|::([0-9a-fA-F]{1,4}){0,7})$/;
export const DEPARTMENT_NAME_REGEX = /^[a-zA-Z0-9-_]+$/;
export const ALPHANUMERIC_REGEX = /[a-zA-Z0-9]/;
export const NO_SPECIALCHAR = /^[A-Za-z0-9]+$/;
export const TAG_NAME_REGEX = /^[A-Za-z0-9_-]+$/;
export const OVERLAY_NAME_REGEX = /^[A-Za-z0-9_-]*$/;
export const ALPHANUMERIC_DASH = /^[A-Za-z0-9-]+$/;
export const ALPHANUMERIC_DASH_UNDERSCORE_SPACE = /^[A-Za-z0-9 _-]+$/;

export const ADD_NEW_TEAM_MEMBER = 'AddNewMember';
export const EDIT_TEAM_MEMBER = 'EditTeamMember';

export const MIN_RECORDS_FOR_CLIENT_GRID = 12;

export const IS_HOT_LEAD_FORM_VISIBLE = false;

export const MULTI_CLIENT_VIEW_TOGGLE = {
  LIST_VIEW: 'list-view',
  GRID_VIEW: 'grid-view',
};

export enum PERMISSION_GROUP_FILTER_TYPE {
  ALL = 'ALL',
  CLIENT = 'CLIENT',
  PROJECT = 'PROJECT',
}

export const CHAR_LIMIT_500 = 500;
export const PROJECT_ID_LIMIT_40 = 40;

export const TABLE_PER_PAGE_5000_ROW = 5000;

export const MIN_SEARCH_CHAR = 4;
export const MIN_SEARCH_CHAR_FOR_ENTER = 1;

export const ALERT_CARD_WIDTH = 456;
export const ALERT_CAROUSEL_CARD_TRANSLATEBY_SIZE = 480;

export const TABLE_PAGE_SIZE_OPTION = [25, 50, 100];
export const TABLE_DEFAULT_PAGE_NUMBER = 1;
export const NEW_PENDING_PROJECTS_PAGE_SIZE = 10;
export const TABLE_PER_PAGE_DEFAULT_NO_ROW = 25;
export const TABLE_PER_PAGE_DEFAULT_50_ROW = 50;
export const CONCIERGE_REPORTS_ACCEPT_FILE =
  '.xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .doc, .docx, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .pdf, application/pdf';
export const MAX_CHAR = 500;
export const CONCIERGE_FORM_TYPE = {
  UPLOAD: 'upload',
  EDIT: 'edit',
};
export const footerLinksURLs = {
  PRIVACY_POLICY_GDPR: 'https://www.consilio.com/privacy/privacy-policy',
  COOKIE_POLICY: 'https://www.consilio.com/privacy/cookie-policy',
  MODERN_ANTI_SLAVERY_POLICY:
    'https://www.consilio.com/modern-anti-slavery-policy',
};
export const PROJECT_DROP_DOWN_ID = 'Project';
export const WORKSPACE_DROP_DOWN_ID = 'Workspace';
export const defaultReportFileName = 'custom report';
export const PROJECT_LIST_SEARCH_ENABLE_COUNT = 12;
export const MODAL_PROJECT_DROP_DOWN_ID = 'ModalProject';
export const failedToLoadStatusCodes = [500, 504];
export const CUSTOM_REPORT_COL_HEIGHT = 57;
export const INVOICE_REPORT_GRID_ERROR_COMPONENT = 69;
export const ERROR_STATUS_CODE = {
  STATUS_403: 403,
  STATUS_404: 404,
  STATUS_409: 409,
  STATUS_502: 502,
  STATUS_503: 503,
};
export const TOAST_TIMEOUT = 5000;
export const DEFAULT_START_DATE_REPORTS = new Date(1975, 0, 1).toString();
export const ECA_PERMISSION_CODES = [
  'ECA_NON_ADMIN_ONEOF',
  'ECA_ADMIN_ONEOF',
  'ECA_NONE',
];
export enum ECA_PERMISSION_CODES_CONSTANTS {
  ECA_NON_ADMIN_ONEOF = 'ECA_NON_ADMIN_ONEOF',
  ECA_ADMIN_ONEOF = 'ECA_ADMIN_ONEOF',
  ECA_NONE = 'ECA_NONE',
  ECA_CREATE_DOCUMENT = 'ECA_CREATE_DOCUMENT',
  ECA = 'ECA',
  ECI_DOCUMENT_PREVIEW = 'ECI_DOCUMENT_PREVIEW',
  ECI_CREATE_DOC_SUMMARY = 'ECI_CREATE_DOC_SUMMARY',
  ECI_DOCUMENT_TAGGING = 'ECI_DOCUMENT_TAGGING',
  ECI_OVERLAYS = 'ECI_OVERLAYS',
  ECI_EXPORTS = 'ECI_EXPORTS',
  ECI_AUDIT_REPORTS = 'ECI_AUDIT_REPORTS',
  ECI_SEARCH_TERM_REPORT = 'ECI_SEARCH_TERM_REPORT',
  ECI_AI_INVESTIGATE = 'ECI_AI_INVESTIGATE',
  ECI_INDEXING = 'ECI_INDEXING',
  TYPE_ECI = 'ECI',
  ECI_SEARCHES = 'ECI_SEARCHES',
  ECI_SAVED_SEARCHES = 'ECI_SAVED_SEARCHES',
  ECI_MANAGE_SAVED_SEARCHES = 'ECI_MANAGE_SAVED_SEARCHES',
  ECI_SAVED_SEARCH_TEMPLATES = 'ECI_SAVED_SEARCH_TEMPLATES',
  ECI_MANAGE_TAG_FIELDS = 'ECI_MANAGE_TAG_FIELDS',
  ECI_MANAGE_CUSTOM_FIELDS = 'ECI_MANAGE_CUSTOM_FIELDS',
}
export enum EVIDENCE_SOURCE_MANAGEMENT {
  STAGING_AREA_ACCESS = 'STAGING_AREA_ACCESS',
  EVIDENCE_SOURCE_UPLOAD_ACCESS = 'EVIDENCE_SOURCE_UPLOAD_ACCESS',
  INITIATE_PROCESSING_ACCESS = 'INITIATE_PROCESSING_ACCESS',
}
export enum BUDGET_TRACKER_CONSTANTS {
  REPORT_BUDGET_CONSUMPTION = 'REPORT_BUDGET_CONSUMPTION',
}

export enum CLIENT_PERMISSION_CODES_CONSTANTS {
  CLIENTS_VIEW = 'CLIENTS_VIEW',
  USERS_VIEW = 'USERS_VIEW',
  MANAGE_PERMISSION_GROUPS = 'MANAGE_PERMISSION_GROUPS',
  EDIT_PROJECT_PROFILE = 'EDIT_PROJECT_PROFILE',
  PROJECT_LEVEL_REPORTS = 'PROJECT_LEVEL_REPORTS',
  CREATE_NEW_PROJECT = 'CREATE_NEW_PROJECT',
}

export enum MANAGE_PROJECT_PERMISSION_CODES_CONSTANTS {
  MANAGE_PROJECT_SETTINGS = 'MANAGE_PROJECT_SETTINGS',
  EDIT_PROJECT_PROFILE = 'EDIT_PROJECT_PROFILE',
  CREATE_NEW_PROJECT = 'CREATE_NEW_PROJECT',
}

export enum REPORT_PERMISSION_CODES_CONSTANTS {
  REPORT_INTAKE_AUDIT_VIEW = 'REPORT_INTAKE_AUDIT_VIEW',
  REPORT_PROCESSING_IN_PROGRESS_VIEW = 'REPORT_PROCESSING_IN_PROGRESS_VIEW',
  REPORT_PROCESSING_SUMMARY_VIEW = 'REPORT_PROCESSING_SUMMARY_VIEW',
  REPORT_INTERACTIVE_VOLUME_VIEW = 'REPORT_INTERACTIVE_VOLUME_VIEW',
  REPORT_USER_SUMMARY_VIEW = 'REPORT_USER_SUMMARY_VIEW',
  REPORT_PRODUCTION_METRICS_VIEW = 'REPORT_PRODUCTION_METRICS_VIEW',
  REPORT_CONCIERGE_REPORTS_VIEW = 'REPORT_CONCIERGE_REPORTS_VIEW',
  REPORT_PROJECT_TRACKER_VIEW = 'REPORT_PROJECT_TRACKER_VIEW',
  REPORT_INVOICE_VIEW = 'REPORT_INVOICE_VIEW',
  REPORT_COMPLETED_MAPPED_DATA_VIEW = 'REPORT_COMPLETED_MAPPED_DATA_VIEW',
  REPORT_PROCESSING_EXCEPTIONS_VIEW = 'REPORT_PROCESSING_EXCEPTIONS_VIEW',
  REPORT_CONCIERGE_REPORTS_CREATE = 'REPORT_CONCIERGE_REPORTS_CREATE',
}

export enum BUSINESS_INTELLIGENCE_PERMISSION_CODES_CONSTANTS {
  PROJECT_LEVEL_REPORTS = 'PROJECT_LEVEL_REPORTS',
}

export enum ECA_DRAWER_ACTIVE_TAB {
  LOADS = 0,
  SAVE_SEARCHES = 1,
  TAGS = 2,
}

export enum BUDGET_ESTIMATED {
  REPORT_BUDGET_CONSUMPTION = 'REPORT_BUDGET_CONSUMPTION',
  REPORT_BUDGET_ALERT = 'REPORT_BUDGET_ALERT',
}

export enum STR_TERMS_TABS {
  FIELD_EDITOR = 0,
  SPLIT_VIEW = 1,
  TERMS_LIST = 2,
}

export enum QUERY_TYPE {
  JSON_LOGIC = 'JSON_LOGIC',
  DT_SEARCH = 'DT_SEARCH',
}

export enum LOAD_TYPE {
  ALL_DOCUMENT = 'ALL_DOCUMENT',
  LOAD_DOCUMENT = 'LOAD_DOCUMENT',
}

export enum LOAD_DOC_TYPE {
  ALL_DOC = 'ALL_DOC',
  LOAD_DOC = 'LOAD_DOC',
  TAG_DOC = 'TAG_DOC',
  SAVED_DOC = 'SAVED_DOC',
  LOAD_SCOPE = 'LOAD_SCOPE',
  TAGS_SCOPE = 'TAGS_SCOPE',
  SAVE_SEARCHES_SCOPE = 'SAVE_SEARCHES_SCOPE',
  SAVED_SEARCHES_EDIT = 'SAVED_SEARCHES_EDIT',
  SAVED_SEARCHES_EDIT_RUN = 'SAVED_SEARCHES_EDIT_RUN',
}

export const SCOPE_TYPE = {
  ALL: 'All',
  TAGS: 'Tags',
  LOAD: 'LoadFile',
  SAVED_SEARCH: 'SavedSearch',
};

export enum SEARCH_SCOPE_TYPE {
  ADHOC = 'Adhoc',
  NLP = 'Nlp',
  SAVED_SEARCH = 'SavedSearch',
}

export const colorArray: AurColorPickerOptionsProp[] = [
  {backgroundColor: '#E6E7E9', textColor: '#000000'},
  {backgroundColor: '#8FA3C1', textColor: '#000000'},
  {backgroundColor: '#A5E9D0', textColor: '#000000'},
  {backgroundColor: '#D6C4F1', textColor: '#000000'},
  {backgroundColor: '#FFCCCC', textColor: '#000000'},
  {backgroundColor: '#FFD6A5', textColor: '#000000'},
  {backgroundColor: '#D9E277', textColor: '#000000'},
  {backgroundColor: '#FF9E2C', textColor: '#000000'},
  {backgroundColor: '#B290E5', textColor: '#000000'},
  {backgroundColor: '#55D5A7', textColor: '#000000'},
  {backgroundColor: '#04A269', textColor: '#000000'},
  {backgroundColor: '#4555D6', textColor: '#FFFFFF'},
  {backgroundColor: '#00AFB8', textColor: '#FFFFFF'},
  {backgroundColor: '#764CB6', textColor: '#FFFFFF'},
  {backgroundColor: '#C9043F', textColor: '#FFFFFF'},
  {backgroundColor: '#15181C', textColor: '#FFFFFF'},
];

export const DEFAULT_COLOR = '#15181C';

export const FILTER_TYPE = {
  normal: 'normal',
  advanced: 'advanced',
};

export const COL_TYPE = {
  string: 'string',
  text: 'text',
  date: 'date',
  number: 'number',
  keyword: 'keyword',
  time: 'time',
  dateTime: 'datetime',
};

export const FILTER_OPERATORS = {
  contains: 'contains',
  signEqual: '=',
  is: 'is',
  between: 'between',
  equals: 'equals',
};

export const MAX_CHAR_LIMIT = 50;

export const SOURCE_TYPE = {
  load: 'load',
  savedSearch: 'savedSearch',
  tag: 'tag',
  custodian: 'custodian',
  processingException: 'processingException',
  docType: 'docType',
  docsWithLoad: 'docsWithLoad',
  notTagged: 'docsNotYetTagged',
  notExported: 'docsNotExported',
  exported: 'docsExported',
};

export const QUERY_PREFIX = {
  load: 'LoadID',
  tag: 'mytagfield',
  custodian: 'AllProcessedCustodians',
  processingException: 'ProcessingExceptionCategory',
  docType: 'FileType',
  savedSearch: 'SavedSearch',
  notExported: 'NOT ExportedToReview',
  exported: 'ExportedToReview',
};

export enum PERMISSION_GROUP_CATEGORY {
  CLIENT = 1,
  PROJECT = 2,
}

export const SUMMARY_FILE_TYPE = [
  'ppt',
  'xlsx',
  'xls',
  'eml',
  'email',
  'pdf',
  'doc',
  'docx',
  'pptx',
  'document',
];

export enum SSE_SERVICE_TYPE {
  INDEX_SERVICE = 1,
  SEARCH_SERVICE = 2,
  NLP_SEARCH = 3,
  SEARCH_TERM_REPORT_SERVICE = 4,
  TAG_SERVICE = 5,
  EXPORT_SERVICE = 6,
}

export enum AUR_DATE_PICKER_OPTIONS {
  STRICK_DATE = 'STRICK_DATE',
  DATE_TIME = 'DATE_TIME',
  STRICK_TIME = 'STRICK_TIME',
}

export enum Status {
  InProgress = 'InProgress',
  CompletedWithError = 'CompletedWithError',
}

export enum TaggingStatus {
  Completed = 'Completed',
}

export enum ToastType {
  Success = 'success',
  Error = 'error',
  Failed = 'failed',
}

export enum ID_SUFFIX {
  SAVED_SEARCH = '.saveSearch',
  PARENT_TAG = '.tagParent',
  CHILD_TAG = '.tagChild',
}

export enum EvidenceStatuses {
  IN_PROCESSING = 'Processing',
  PENDING_APPROVAL = 'PendingApproval',
  PROCESSED = 'Processed',
  PROCESSED_WITH = 'processedWith',
  MAPPING_DATA = 'MappingData',
  MAPPING_COMPLETE = 'MappingComplete',
  PROCESSING_FAILED = 'Error',
  STAGED = 'Staged',
  INTAKE_DATA_COPYING = 'DataCopy',
  INTAKE_Extraction = 'Extract',
  INTAKE_VIRUS_SCANNING = 'VirusScan',
  INTAKE_COPY_TO_OUTPUT = 'CopyToOutput',
  INTAKE_BEING_PARSED = 'Parse',
  INTAKE_BATCHING = 'Batch',
  INTAKE_PENDING = 'IntakePending',
  IN_PROCESSING_MANUAL = 'ProcessingManual',
}

export enum EvidenceSubStatus {
  IN_PROCESSING_MANUAL = 'manual',
  STAGED_FOR_PROCESSING = 'stagedForProcessing',
  INTAKE = 'intake',
}

export const INTAKE_STATUSES: EvidenceStatuses[] = [
  EvidenceStatuses.INTAKE_DATA_COPYING,
  EvidenceStatuses.INTAKE_Extraction,
  EvidenceStatuses.INTAKE_VIRUS_SCANNING,
  EvidenceStatuses.INTAKE_COPY_TO_OUTPUT,
  EvidenceStatuses.INTAKE_BEING_PARSED,
  EvidenceStatuses.INTAKE_BATCHING,
  EvidenceStatuses.INTAKE_PENDING,
];

export const MAX_ATTEMPTS = 3;
export const DELAY_MS = 10000;
export const BUDGET_PERCENTAGE_LIMIT = 70;
export const BUDGET_AlERT_COUNT_UPTO_ONE = 1;
export const BUDGET_CONSUMPTON_PERCENTAGE = 100;
export const REBUILD_TOAST_TIMEOUT = 8000;
export const INDEXING_HISTORY = 'IndexingHistory';
export const INDEXING_SUB_INFO = 'info';
export const INDEXING_SUBINDEX_EVENTS = 'Sub Index Events';
export const INDEXING_SUBINDEX_HEIGHT = 36;
export const INDEXING_SUBINDEX_CHILD = 'child';
export const INDEXING_PARENT = 'parent';
export const BUDGET_ALERT_TYPE = 'BudgetTracker';
export const INDEXING_STANDARD_MEDIA = 'Media';
export const INDEXING_STANDARD_FULL_PROJECT = 'Full Project';
export const BLANK = 'blank';

export const EVIDENCE_UPLOAD_PERMISSION_TYPE = 'EvidenceSourceUpload';
export const EARLY_CASE_INTELLIGENCE_TYPE = 'ECI';
export const ECI_UI_ORDER: string[] = [
  'Searches',
  'Saved Searches',
  'Search Term Reports',
  'Document Preview',
  'Manage Saved Searches',
  'Saved Search Templates',
  'AI Investigate',
  'Document Summary Generation',
  'Tagging Documents',
  'Create/Edit Tag Fields',
  'Create/Edit Custom Fields',
  'Exports/Promotions',
  'Indexing (Elastic and NLP)',
  'Overlays',
  'Audit Reports',
];
export const FILTER_DATE_FORMAT = 'YYYY-MM-DD';
export const ONLY_DATE_SHOW_FORMAT = 'YYYY/MM/DD';
export const ONLY_TIME_SHOW_FORMAT = 'HH:mm';
export const FULL_UTC_DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss UTC';
export const FULL_DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss';

export const SPEED_TEST_URL = 'https://speedtest-lvs.consilio.com/';
export const fileCatalystURLs = {
  GET_FILECATALYST_LINK: 'https://filecatalyst.software/direct.html',
  LEARN_MORE_LINK:
    'https://www.goanywhere.com/products/filecatalyst/filecatalyst-direct',
};

export enum EciHomePageTabs {
  ECI_OVERVIEW = 'eci-overview',
  STR = 'search-term-report',
}

export enum COUNTRY_CODES {
  UNITED_STATE = 'us',
  HONG_KONG = 'hk',
  CHINA = 'cn',
  UNITED_KINGDOM = 'uk',
  GREAT_BRITAIN = 'gb',
}
export const DEFAULT_PROJECT_COUNTRY_CODE = COUNTRY_CODES.UNITED_STATE;

export const INTENT = {
  LAUNCH_ECI: 'launch_eci',
};

export const HOST_URLS = {
  DEV: 'https://aurora-dev1.consiliotest.com',
  QA: 'https://aurora-qa1.consiliotest.com',
  UAT1: 'https://aurora-uat1.consilio.com',
  UAT2: 'https://aurora-uat2.consilio.com',
};

export const PERMISSION_TYPE = {
  BUDGET: 'BUDGET',
  ECI: 'ECI',
  REPORTS: 'Reports',
  EVIDENCE: 'EvidenceSourceUpload',
  SYSTEM: 'System',
  MANAGE_PROJECT: 'ManageProject',
  BUSINESS_INTELLIGENCE: 'BusinessIntelligence',
};

export const PERMISSION_NAME_MAP: Record<string, string> = {
  // System
  [CLIENT_PERMISSION_CODES_CONSTANTS.CLIENTS_VIEW]:
    'permission.system.manageClientSettings',
  [CLIENT_PERMISSION_CODES_CONSTANTS.USERS_VIEW]:
    'permission.system.manageUsers',
  [CLIENT_PERMISSION_CODES_CONSTANTS.MANAGE_PERMISSION_GROUPS]:
    'permission.system.managePermissionGroups',

  // Manage Project
  [MANAGE_PROJECT_PERMISSION_CODES_CONSTANTS.MANAGE_PROJECT_SETTINGS]:
    'permission.manageProject.settings',
  [MANAGE_PROJECT_PERMISSION_CODES_CONSTANTS.EDIT_PROJECT_PROFILE]:
    'permission.manageProject.editProfile',
  [MANAGE_PROJECT_PERMISSION_CODES_CONSTANTS.CREATE_NEW_PROJECT]:
    'permission.manageProject.createNewProjects',

  // Reports
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_INTAKE_AUDIT_VIEW]:
    'permission.report.intakeAudit',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_PROCESSING_IN_PROGRESS_VIEW]:
    'permission.report.processingInProgress',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_PROCESSING_SUMMARY_VIEW]:
    'permission.report.processingSummary',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_PROCESSING_EXCEPTIONS_VIEW]:
    'permission.report.processingExceptions',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_INTERACTIVE_VOLUME_VIEW]:
    'permission.report.reviewWorkspaceCounts',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_USER_SUMMARY_VIEW]:
    'permission.report.reviewWorkspaceUsers',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_PRODUCTION_METRICS_VIEW]:
    'permission.report.highLevelProductionMetrics',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_INVOICE_VIEW]:
    'permission.report.invoiceReport',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_PROJECT_TRACKER_VIEW]:
    'permission.report.projectTracker',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_CONCIERGE_REPORTS_VIEW]:
    'permission.report.customReports',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_CONCIERGE_REPORTS_CREATE]:
    'permission.report.customReportsUpload',
  [REPORT_PERMISSION_CODES_CONSTANTS.REPORT_COMPLETED_MAPPED_DATA_VIEW]:
    'permission.report.completedMappedData',

  // Budget
  [BUDGET_ESTIMATED.REPORT_BUDGET_CONSUMPTION]:
    'permission.budget.viewEstimatedBudget',
  [BUDGET_ESTIMATED.REPORT_BUDGET_ALERT]: 'permission.budget.showBudgetAlerts',

  // ECI
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_SEARCHES]: 'permission.eca.searches',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_SAVED_SEARCHES]:
    'permission.eca.savedSearches',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_SAVED_SEARCH_TEMPLATES]:
    'permission.eca.savedSearchTemplates',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_DOCUMENT_PREVIEW]:
    'permission.eca.documentPreview',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_MANAGE_SAVED_SEARCHES]:
    'permission.eca.manageSavedSearches',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_SEARCH_TERM_REPORT]:
    'permission.eca.searchTermReports',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_AI_INVESTIGATE]:
    'permission.eca.aiInvestigate',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_CREATE_DOC_SUMMARY]:
    'permission.eca.documnetSummaryGeneration',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_DOCUMENT_TAGGING]:
    'permission.eca.taggingDocumnets',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_INDEXING]: 'permission.eca.indexing',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_OVERLAYS]: 'permission.eca.overlays',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_MANAGE_TAG_FIELDS]:
    'permission.eca.createEditTagFields',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_MANAGE_CUSTOM_FIELDS]:
    'permission.eca.createEditCustomFields',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_EXPORTS]:
    'permission.eca.exportsPromotions',
  [ECA_PERMISSION_CODES_CONSTANTS.ECI_AUDIT_REPORTS]:
    'permission.eca.auditReports',

  // Evidence Source Management
  [EVIDENCE_SOURCE_MANAGEMENT.STAGING_AREA_ACCESS]:
    'permission.evidenceSourceManagement.manageProjectEvidence',
  [EVIDENCE_SOURCE_MANAGEMENT.EVIDENCE_SOURCE_UPLOAD_ACCESS]:
    'permission.evidenceSourceManagement.uploadRights',
  [EVIDENCE_SOURCE_MANAGEMENT.INITIATE_PROCESSING_ACCESS]:
    'permission.evidenceSourceManagement.initiateProcessingRights',

  // Business Intelligence
  [BUSINESS_INTELLIGENCE_PERMISSION_CODES_CONSTANTS.PROJECT_LEVEL_REPORTS]:
    'permission.businessIntelligence.projectLevelReports',
};
